function BarChartSkeleton() {
    return (
        <div className="bg-white rounded-xl shadow-lg w-full p-6 animate-pulse">
            <div className="flex justify-end space-x-4 mb-4">
                <div className="flex items-center space-x-2">
                    <div className="w-3.5 h-3.5 bg-gray-300 rounded-sm"></div>
                    <div className="w-14 h-3 bg-gray-300 rounded"></div>
                </div>
                <div className="flex items-center space-x-2">
                    <div className="w-3.5 h-3.5 bg-gray-300 rounded-sm"></div>
                    <div className="w-14 h-3 bg-gray-300 rounded"></div>
                </div>
            </div>

            <div className="flex w-full">
                <div className="flex flex-col justify-between h-64 sm:h-80 w-8 pr-2 text-right">
                    {[...Array(6)].map((_, i) => (
                        <div key={i} className="w-full h-3 bg-gray-300 rounded"></div>
                    ))}
                </div>

                <div className="flex-1 pl-2">
                    <div className="relative h-64 sm:h-80">
                        <div className="absolute inset-0 flex flex-col justify-between">
                            {[...Array(6)].map((_, i) => (
                                <div key={i} className="h-px bg-gray-200" />
                            ))}
                        </div>

                        <div className="absolute inset-0 flex justify-around items-end z-10">
                            {[...Array(6)].map((_, i) => (
                                <div
                                    key={i}
                                    className="flex items-end space-x-1 h-full w-full px-1 justify-center"
                                    style={{ maxWidth: '80px' }}
                                >
                                    <div
                                        className="w-1/2 bg-gray-300 rounded-t-md"
                                        style={{ height: `${40 + (i % 3) * 15}%` }}
                                    ></div>
                                    <div
                                        className="w-1/2 bg-gray-200 rounded-t-md"
                                        style={{ height: `${60 + ((i + 1) % 3) * 10}%` }}
                                    ></div>
                                </div>
                            ))}
                        </div>

                        <div className="absolute bottom-0 left-0 right-0 h-px bg-gray-200"></div>
                    </div>

                    <div className="flex justify-around mt-3">
                        {[...Array(6)].map((_, i) => (
                            <div key={i} className="w-full h-3 bg-gray-300 rounded mt-2 mx-1" style={{ maxWidth: '80px' }}></div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="mt-8 pt-6 border-t border-gray-200">
                <div className="w-1/2 h-4 bg-gray-300 rounded mt-2"></div>
            </div>
        </div>
    )
}

export default BarChartSkeleton